<app-diagnosis-table type="Pests"></app-diagnosis-table>
